function isFunction(x) {
    return Object.prototype.toString.call(x) == '[object Function]';
}

export const debounce = (fn, wait) => {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    }
}

export const parseHTML = (text) => {
    return new DOMParser().parseFromString(text, 'text/html');
}

export const fetchHTML = (URL) => fetch(URL)
    .then(res => res.text())
    .then(text => parseHTML(text))
    .catch(e => console.error(e));

export const $fetch = async (URL, options) => {
    try {
        if(isFunction(options?.before)) {
            options.before();
        }
        const res = await fetch(options.params ? `${URL}?${new URLSearchParams(options.params)}` : URL);
        if(options?.nullOn404 && res.status === 404) {
            if(isFunction(options?.after)) {
                options.after();
            }
            return null;
        }
        const doc = await res.text();
        if(isFunction(options?.after)) {
            options.after();
        }
        const $doc = parseHTML(doc); 
        return options?.selectAll ? 
            Array.from($doc.querySelectorAll(options.selectAll)) : 
            options?.select ? $doc.querySelector(options.select) : $doc;

    } catch (error) {
        console.error(error);
        if(isFunction(options?.after)) {
            options.after();
        }
    }
}

export const loadScript = (name) => {
    const src = window.theme.scripts[name];
    const existedScript = document.querySelector(`script[src="${src}"]`);
    return new Promise((res, rej) => {
        if(existedScript) {
            if(existedScript.hasAttribute('loaded')) {
                res();
            } else {
                const observer = new MutationObserver((mList, obs) => {
                    for(const m of mList) {
                        if(m.attributeName === 'loaded') {
                            obs.disconnect();   
                            res();
                        }
                    }
                });
                observer.observe(existedScript, { attributes: true, childList: false, subtree: false });
            }            
        } else {
            const script = document.createElement('script');
            script.src = src;
            script.defer = true;
            document.body.appendChild(script);
            script.onload = () => {
                script.setAttribute('loaded', '');
                res();
            }
        }
    })
}

export const $hide = (element) => {
    element.setAttribute('hidden', '');
}

export const $show = (element) => {
    element.removeAttribute('hidden', '');
}

export const $classListTemp = (element, className, time = 1000) => {
    element.classList.add(className);
    setTimeout(() => element.classList.remove(className), time)
}

export const $isEmpty = (element) => {
    if(element.content) {
        element = element.content;
    }
    return element.textContent.trim() === "";
}

export const $isHidden = (element) => element.hasAttribute('hidden');

export const $clone = (element) => element.content.cloneNode(true);

export const $isEqual = (el1, el2) => el1.isEqualNode(el2);

export const $toggleDisplay = (el, state) => {
    if(state === undefined) {
        $isHidden(el) ? $show(el) : $hide(el);
        return;
    }

    state ? $show(el) : $hide(el);
}

export const $replaceContent = (from, to) => {
    const target = to.content || to;
    if(!$isEqual(from, target)) {
        from.replaceChildren(...target.cloneNode(true).childNodes);
    }
}

export const $hover = (el, callback) => {
    el.addEventListener('mouseover', (e) => {
        callback(e, true);
    });
    el.addEventListener('mouseleave', (e) => {
        callback(e, false);
    });
}

export const arrEq = (arr1, arr2) => arr1.toString() === arr2.toString();

export const $JSON = (el) => JSON.parse(el.textContent);


const chacheStore = {};

export const cache = {
    get: (item) => {
        return chacheStore[item];
    },
    set: (item, value) => {
        return chacheStore[item] = value;
    },
    list: chacheStore
};

export const Routes = (name) => {
    return window.dynamicURLs[name]
}

export const publishEvent = (eventName, data, sectionId) => {
    const event = new CustomEvent(eventName, {
    	bubbles: false,
        cancelable: true,
        composed: true,
        detail: {
            sectionId,
            data
        }
    })
    document.dispatchEvent(event);
}

// export const cartProvider = (caller) => {
//     const CART_SECTION = 'r_cart';

//     class CartProviderClass {
//         constructor(caller) {
//             this.caller = caller;
//         }

//         async add(data, mainId) {
//             this.routeURL = Routes('cartAdd');
//             try {
//                 const res = await this._fetchCartData({ items: data });
//                 const cartData = await res.json();
//                 if(!res.ok) {
//                     throw new Error(JSON.stringify(cartData));
//                 }
//                 this.cartData = cartData;
//                 this._setFirstItem(mainId);
//                 this._publishUpdates();
//             this.caller.publish('drawer:open');
//             } catch(e) {
//                 const { message = '', description = '' } = JSON.parse(e.message);
//                 console.error(e);
//                 (message || description) && publishEvent(
//                     'toast-notification:open', 
//                     {   
//                         title: message, 
//                         message: description, 
//                         type: 'error' 
//                     }
//                 )
//                 publishEvent('cart:error');
//             }
            
//         }
        
//         async update(id, quantity, selling_plan, line) {
//             this.routeURL = Routes('cartChange');
//             const res = await this._fetchCartData({ id, quantity, selling_plan, line });
//             const cartData = await res.json();
//             this.cartData = cartData;
//             this._publishUpdates();
//             // this.caller.publish('drawer:update');

//             // NOTE: I have no idea why, buy try/catch block executes wierdly on mobile device (iOS)
//             // should dive deeper into that

//             // return;

//             // try {
//             //     publishEvent(
//             //         'toast-notification:open', 
//             //         {   
//             //             message: JSON.stringify({ id, quantity }), 
//             //             type: 'success' 
//             //         }
//             //     )
//             //     return;
//             //     const res = await this._fetchCartData({ id, quantity });
//             //     const cartData = await res.json();
                
//             //     return;
//             //     if(!res.ok) {
//             //         throw new Error(JSON.stringify(cartData));
//             //     }
//             //     this.cartData = cartData;
//             //     this._publishUpdates();
//             // } catch (e) {
//             //     const { message = '', description = '' } = JSON.parse(e.message);
//             //     console.error(e);
//             //     (message || description) && publishEvent(
//             //         'toast-notification:open', 
//             //         {   
//             //             title: message, 
//             //             message: description, 
//             //             type: 'error' 
//             //         }
//             //     )
//             //     publishEvent('cart:error');
//             // }
            
//         }

//         async _fetchCartData(data) {
//             return fetch(`${this.routeURL}.js`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Accept': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     ...data,
//                     sections: [CART_SECTION],
//                     sections_url: Routes('cart')
//                 })
//             });
//         }

//         // async __fetchCartData(itemsData) {
//         //     let error = false;
//         //     this.cartData = await fetch(`${this.routeURL}.js`, {
//         //         method: 'POST',
//         //         headers: {
//         //             'Content-Type': 'application/json',
//         //             'Accept': 'application/json'
//         //         },
//         //         body: JSON.stringify({
//         //             ...itemsData,
//         //             sections: [CART_SECTION],
//         //             sections_url: Routes('cart')
//         //         })
//         //     }).then(cartRes => {
//         //         // publishEvent(
//         //         //     'toast-notification:open', 
//         //         //     {   
//         //         //         message: JSON.stringify(cartRes), 
//         //         //         type: 'error' 
//         //         //     }
//         //         // )
//         //         if(!cartRes.ok) {
//         //             error = true;
//         //         }
//         //         return cartRes.json()
//         //     }).then(d => {
//         //         if(error) {
//         //             throw new Error(JSON.stringify(d));
//         //         }
//         //         return d;
//         //         // if (!error) return d;
//         //     })
//         // }

//         _setFirstItem(mainId) {
//             const matchItem = this.cartData.items.find(({ id }) => id === +mainId);
//             if (!matchItem) return;
//             this.cartData.items = [ matchItem, ...this.cartData.items.filter(item => item !== matchItem) ];
//         }

//         _publishUpdates() {
//             const doc = parseHTML(this.cartData.sections[CART_SECTION]);
//             this.caller.publish('cart:update', {
//                 items: this.cartData.items,
//                 getItems: () => doc.querySelector('[data-cart-items]'),
//                 getEmptyMsg: () => doc.querySelector('[data-cart-empty]'),
//                 getItemCount: () => doc.querySelector('[data-cart-item-counter]').innerText,
//                 getCount: () => doc.querySelector('[data-cart-counter]').innerText,
//                 getSubtotal: () => doc.querySelector('[data-cart-subtotal]').innerText,
//                 getSubtotalBlock: () => doc.querySelector('[data-cart-subtotal-block]'),
//                 src: this.caller.tagName
//             });
//         }
//     }

//     return new CartProviderClass(caller);
// }